import { keyframes, styled, theme } from '../stitches.config';

const shimmerAnimation = keyframes({
  '100%': { transform: 'translateX(100%)' },
});

const SkeletonContainer = styled('div', {
  overflow: 'hidden',
  position: 'relative',
  '&:after': {
    transform: 'translateX(-100%)',
    position: 'absolute',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    animation: `${shimmerAnimation} 3s infinite`,
    background:
      'linear-gradient( 90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0))',
    content: '',
  },
});

const SkeletonSpan = styled('span', {
  background: theme.colors.gray3,
  display: 'block',
  borderRadius: '4px',
  variants: {
    size: {
      medium: {
        width: '100vw !important',
        height: '100vh',
      },
      small: {
        width: '100vw !important',
        height: '100vh',
      },
    },
  },
});

interface SkeletonLoaderProps {
  height?: string;
  width?: string;
  background?: string;
}

export const SkeletonLoader = ({
  height,
  width,
  background,
}: SkeletonLoaderProps) => {
  return (
    <SkeletonContainer className="skeleton">
      <SkeletonSpan
        style={{
          width: width,
          height: height,
          background: background || theme.colors.gray3.value,
        }}
        size={{ '@sm': 'small', '@md': 'medium' }}
      />
    </SkeletonContainer>
  );
};
